import { createContext, useContext, useState } from "react";
import type { ReactNode } from "react";

// Gym 정보 타입 정의
interface GymData {
    gymId: number;
    externalGymId: string;
    gymName: string;
    broadcastYn: string;
    // 필요한 추가 체육관 정보가 있다면 여기에 추가
}

// Context에서 제공할 값 타입 정의
interface GymContextType {
    gymData: GymData | null;
    setGymData: (data: GymData) => void;
    clearGymData: () => void;
    externalGymId: string | null;
}

// Context 생성
const GymContext = createContext<GymContextType | undefined>(undefined);

// Provider 컴포넌트 정의
export function GymProvider({ children }: { children: ReactNode }) {
    const [gymData, setGymDataState] = useState<GymData | null>(null);

    // 체육관 데이터 설정 함수
    const setGymData = (data: GymData) => {
        setGymDataState(data);
    };

    // 체육관 데이터 초기화 함수
    const clearGymData = () => {
        setGymDataState(null);
    };

    // externalGymId 계산하기
    const externalGymId = gymData?.externalGymId || null;

    // Context에서 제공할 값
    const value = {
        gymData,
        setGymData,
        clearGymData,
        externalGymId,
    };

    return <GymContext.Provider value={value}>{children}</GymContext.Provider>;
}

// 커스텀 훅 생성
export function useGym() {
    const context = useContext(GymContext);
    if (context === undefined) {
        throw new Error("useGym must be used within a GymProvider");
    }
    return context;
} 